/**
 * Check if the application is running with production build.
 */
export function isProduction(): boolean {
  return import.meta.env.PROD;
}
